<template>
  <transition name="el-fade-in-linear">
    <div class="product product-new" :style="zoomStyle">
      <div class="panel-box panel-1">
        <div class="panel-content">
          <h2 class="en-title">
            Nebula Edge Intelligent Analysis All-in-One Machine
          </h2>
          <h1 class="ch-title">北斗星辰边缘智能分析一体机</h1>
        </div>
      </div>
      <div class="aspect-ratio-box">
        <div class="aspect-ratio-box-content">
          <div class="center-box">
            <p class="desept-new">
              北斗星辰边缘智能分析一体机是一款融合视频与物联传感，集通、感、算、控于一体的国产化智能设备，充分利用智能视频分析算法和AIOT场景编排技术，实现跨边缘设备的自主感知。产品功能包括AI视频分析、告警管理、物联设备、情景联动、多模态大模型协同计算、数字孪生、设备管理、资源监控、远程升级等。
            </p>
            <img
              class="title-bg"
              src="../../static/images/product-part1.png"
              alt=""
            />

            <div class="overview-bottom">
              <div>
                <img
                  class="title-bg"
                  src="../../static/images/product-part2.png"
                  alt=""
                />
              </div>
              <div class="item-wrapper">
                <div class="part2-item">
                  <img
                    class="part2-item-icon"
                    src="../../static/images/icon-part2-1.png"
                    alt=""
                  />
                  <p class="part2-item-title">目标检测类</p>
                </div>
                <div class="part2-item">
                  <img
                    class="part2-item-icon"
                    style="margin-top: 14px;"
                    src="../../static/images/icon-part2-2.png"
                    alt=""
                  />
                  <p class="part2-item-title" style="">
                    人、机动车、非机动车<br/>视频结构化类
                  </p>
                </div>
                <div class="part2-item">
                  <img
                    class="part2-item-icon"
                    src="../../static/images/icon-part2-3.png"
                    alt=""
                  />
                  <p class="part2-item-title">人脸识别类</p>
                </div>
                <div class="part2-item">
                  <img
                    class="part2-item-icon"
                    src="../../static/images/icon-part2-4.png"
                    alt=""
                  />
                  <p class="part2-item-title">人体姿态类</p>
                </div>
                <div class="part2-item">
                  <img
                    class="part2-item-icon"
                    src="../../static/images/icon-part2-5.png"
                    alt=""
                  />
                  <p class="part2-item-title">异常事件类</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel-box" style="margin-top: 47px;">
        <div class="panel-content">
          <div>
            <img
              class="title-bg"
              src="../../static/images/product-part3.png"
              alt=""
            />
          </div>
          <img class="gn-img" src="../../static/images/part3-img.png" alt="" />
        </div>
      </div>

      <div class="panel-box" style="margin-top: 47px;margin-bottom: 60px;">
        <div class="panel-content">
          <div class="product-wrapper">
            <div class="product-item">
              <div class="pro-info-new">
                <p class="pro-info-des-new">
                  支持6路（任务/秒）高清视频智能分析<br />适用设备房、教室等场景
                </p>
                <img
                  class="box-img"
                  src="../../static/images/box-1.png"
                  alt=""
                />
                <p class="pro-info-name-new">Nebula_E_All_2001</p>
              </div>
              <div class="pro-config-new">
                <img
                  class="config-img-new"
                  src="../../static/images/box1-config.png"
                  alt=""
                />
                <p class="line"></p>
                <!-- <p class="price">¥ 20,000</p> -->
              </div>
            </div>
            <div class="product-item">
              <div class="pro-info-new">
                <p class="pro-info-des-new">
                  支持16路（任务/秒）高清视频智能分析<br />带单北斗定位，适用公交车、九小场所等场景
                </p>
                <img
                  class="box2-img"
                  src="../../static/images/box-2.png"
                  alt=""
                />
                <p class="pro-info-name-new">Nebula_E_All_2002</p>
              </div>
              <div class="pro-config-new">
                <img
                  class="config-img-new"
                  src="../../static/images/box2-config.png"
                  alt=""
                />
                <p class="line"></p>
                <!-- <p class="price">¥ 52,000</p> -->
              </div>
            </div>
            <div class="product-item">
              <div class="pro-info-new">
                <p class="pro-info-des-new">
                  支持112路（任务/秒）高清视频智能分析<br />适用枢纽、体育馆、学校等场景
                </p>
                <img
                  class="box3-img"
                  src="../../static/images/box-3.png"
                  alt=""
                />
                <p class="pro-info-name-new">Nebula_E_All_2303</p>
              </div>
              <div class="pro-config-new">
                <img
                  class="config-img-new"
                  src="../../static/images/box3-config.png"
                  alt=""
                />
                <p class="line"></p>
                <!-- <p class="price">¥ 360,000</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="prodctFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>

<script>
import Foot from "./Foot";
export default {
  name: "WiseBrain",
  data() {
    return {
      zoomStyle: ""
    };
  },
  metaInfo() {
    // 改为函数
    return {
      title: "北斗星辰边缘智能分析一体机",
      meta: [
        {
          name: "keywords",
          content:
            "星辰边缘智能分析一体机价格 边缘设备报价 AIOT智慧平台 一体机 视频Ai分析"
        },
        {
          vmid: "desc",
          name: "description",
          content:
            "北斗星辰边缘智能分析一体机是一款融合视频与物联传感，集通、感、算、控于一体的国产化智能设备，充分利用智能视频分析算法和AIOT场景编排技术，实现跨边缘设备的自主感知。产品功能包括AI视频分析、告警管理、物联设备、情景联动、多模态大模型协同计算、数字孪生、设备管理、资源监控、远程升级等"
        }
      ]
    };
  },
  mounted: function() {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });

    this.$nextTick(() => {
      // 监听窗口大小变化事件
      window.onresize = () => {
        let width = document.documentElement.clientWidth;
        let scale = 1;
        if (width <= 1100) {
          scale = width / 1100;
        }
        this.zoomStyle = "zoom:" + scale;
      };
    });
  },
  components: {
    Foot
  },
  methods: {},
  activated() {
    this.$meta().refresh(); // 强制刷新 meta
  },
  watch: {
    $route(to, from) {
      this.$meta().refresh();
    }
  }
};
</script>
<style scoped>
@import "./Product.css";
</style>



// WEBPACK FOOTER //
// src/views/Product.vue